import { useEffect, useRef } from "react";

import { AlphaGameIcon } from "../icons/AlphaGameIcon";

export function AlphaQuickGuide({
  onClose,
  onRestartWelcome,
}: {
  readonly onClose: () => void;
  readonly onRestartWelcome: () => void;
}) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    closeRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <aside
      className="alpha-quick-guide"
      role="dialog"
      aria-modal="true"
      aria-labelledby="alpha-guide-title"
    >
      <header>
        <div>
          <p className="alpha-kicker">Quick Guide</p>
          <h2 id="alpha-guide-title">How to Play</h2>
        </div>
        <button ref={closeRef} className="alpha-link-button" type="button" onClick={onClose}>
          Close
        </button>
      </header>
      <section>
        <h3>
          <AlphaGameIcon name="banner" aria-hidden="true" /> Goal
        </h3>
        <p>Claim two lanes. Reduce an opposing Land's Control to zero to earn a Victory Banner.</p>
      </section>
      <section>
        <h3>
          <AlphaGameIcon name="phase" aria-hidden="true" /> Action window
        </h3>
        <p>
          Ready, Draw, and ordinary Supply resolve automatically. Play cards, Events, and attacks in
          any legal order, then press End Turn once.
        </p>
      </section>
      <section>
        <h3>
          <AlphaGameIcon name="land" aria-hidden="true" /> Cards
        </h3>
        <p>
          Drag cards onto glowing lanes during your action window. An Army may station on any active
          friendly Land; only one Commander-or-Army Deployment Action is available each turn.
        </p>
      </section>
      <section>
        <h3>
          <AlphaGameIcon name="attack" aria-hidden="true" /> Combat
        </h3>
        <p>
          Visible Attack minus visible Guard is possible Control damage. Select or drag a
          Commander-led formation toward a glowing Direct or Flank target.
        </p>
      </section>
      <section>
        <h3>
          <AlphaGameIcon name="discard" aria-hidden="true" /> Cleanup
        </h3>
        <p>Remaining hand cards are discarded and unused resources clear before the turn passes.</p>
      </section>
      <div className="alpha-quick-guide__actions">
        <button
          className="alpha-button alpha-button--secondary"
          type="button"
          onClick={onRestartWelcome}
        >
          Restart welcome guide
        </button>
        <button className="alpha-button alpha-button--primary" type="button" onClick={onClose}>
          Return to match
        </button>
      </div>
    </aside>
  );
}
